import { useEffect, useState } from 'react'
import { ProgressBar } from '../../../components/ProgressBar/ProgressBar'
import { Footer } from '../../../components/Footer/Footer'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import dateAndTimeIcon from '../../../images/DateAndTimeIcon.svg'
import {
  convertTimeIntoMinutes,
  convertMinutesIntoTime
} from '../../../services/Helper'
import { useWebcast } from '../../../hooks/useWebcast'

import { Box, SelectChangeEvent, useMediaQuery } from '@mui/material'
import { container, flexcol, flexItemCenter, root } from '../../../global'
import { useNavigate, useParams } from 'react-router-dom'
import {
  availableTimeSlots,
  eventDetail,
  getBooking,
  selectedSlotRoomId,
  bookTimeSlotsLive,
  updatePublicationDate,
  bookedSlotsPerDate
} from '../../../services/EventService'
import moment from 'moment'
import { appTheme } from '../../../theme'
import SeriesEvents from './SeriesEvents'
import { Message } from '../../../components/Message/Message'
import { EventTitle } from '../../../components/EventTitle/EventTitle'
import { EventDateAndTime } from '../../../components/EventDateAndTime/EventDateAndTime'
import { ProcessingDialog } from '../../../components/InfoDialogs'
import { EventType, Role } from '../../../services/Types'

let user: any = localStorage.getItem('user')
if (user) user = JSON.parse(user)

var isWebView = true
const Item = styled(Paper)(({ theme }) =>
  isWebView
    ? { padding: theme.spacing(0, '96px', 10, '96px') }
    : { padding: theme.spacing(0, 4, 10, 4) }
)

const HorizontalLine = () => {
  return (
    <Box
      sx={{
        width: '100%',
        border: '0.5px solid #C9C5CA'
      }}
    ></Box>
  )
}

export default function DateAndTimesLive() {
  isWebView = !useMediaQuery(appTheme.breakpoints.down('lg'))

  // Time Picker logics end
  const [selectedLiveSlot, setLiveSlot] = useState<string>('')
  const [selectedDrySlot, setDrySlot] = useState<string>('')

  const clickLiveSlot = (slot: any) => {
    setErrorMessage(false)
    setLiveSlot(slot)
  }

  let { id } = useParams()
  const [showErrorMessage, setErrorMessage] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')
  const [event, setEvent] = useState<any>({})
  const [audience, setAudience] = useState(0)

  // Live Event Run Logic start
  const [liveDuration, setLiveDuration] = useState(30)
  const [liveTimeSlots, setLiveTimeSlots] = useState<string[]>([])
  const [eventLiveDate, setEventLiveDate] = useState<Date | null>(
    () => new Date()
  )
  const { minimumLiveDate, getMinimumPublicationDate } = useWebcast()
  const [serialEvents, setSerialEvents] = useState<any[]>([])
  const [isSerialEvent, setSerialEvent] = useState(false)
  const [liveSlotsPerDate, setLiveSlotsPerDate] = useState({})

  // Event Dry Run Logic start
  const [dryDuration, setDryDuration] = useState(30)

  const [publicationDate, setPublicationDate] = useState<Date | null>(
    () => new Date()
  )

  const [isLoading, setLoading] = useState(true)
  const [isLoadingSeries, setLoadingSeries] = useState(true)

  let minimumPublicationDate = getMinimumPublicationDate(eventLiveDate!, liveDuration);

  const [bookingCount, setBookingCount] = useState(0)
  const [bookingLoading, setBookingLoading] = useState(true)

  useEffect(() => {
    setPublicationDate(getMinimumPublicationDate(eventLiveDate!, liveDuration))
  }, [eventLiveDate, liveDuration])

  const displayServerError = () => {
    setValidationMessage('Internal server error')
    showErrorPopup()
  }

  useEffect(() => {
    let bookingData = {
      eventId: id,
      dryDuration: dryDuration,
      selectedDrySlot: selectedDrySlot,
      publicationDate: publicationDate,
      liveDuration: liveDuration,
      selectedLiveSlot: selectedLiveSlot,
      eventLiveDate: eventLiveDate
    }
    let bookingDataStr = JSON.stringify(bookingData)
    localStorage.setItem('bookingData', bookingDataStr)
  }, [dryDuration, liveDuration, selectedDrySlot, selectedLiveSlot])

  const saveBookingDataToLocalStorage = (
    dryDuration: any,
    selectedDrySlot: any,
    publicationDate: any,
    liveDuration: any,
    selectedLiveSlot: any,
    eventLiveDate: any
  ) => {
    let bookingData = {
      eventId: id,
      dryDuration: dryDuration,
      selectedDrySlot: selectedDrySlot,
      publicationDate: publicationDate,
      liveDuration: liveDuration,
      selectedLiveSlot: selectedLiveSlot,
      eventLiveDate: eventLiveDate
    }
    let bookingDataStr = JSON.stringify(bookingData)
    localStorage.setItem('bookingData', bookingDataStr)
  }

  useEffect(() => {
    const loadEventData = async () => {
      try {
        const { data } = await eventDetail(Number(id))
        if (data) {
          if (data.eventDetail.statusCode === 200) {
            if (data.eventDetail.data === null) {
              navigate('/')
            } else {
              if (data.eventDetail.data.status.startsWith('APPROVAL') && user.role !== Role.ADMIN) {
                return navigate('/')
              }

              let liveRoomBooking = data.eventDetail.data.roomBooking?.find((x: any) => x.category === 'live')
              if (liveRoomBooking && Number(liveRoomBooking.date) < moment.utc().set({ h: 0, m: 0, s: 0, ms: 0 }).valueOf() && user.role !== Role.ADMIN) {
                return navigate('/')
              }

              setEvent(data.eventDetail.data)
              if (data.eventDetail.data.eventType !== EventType.SERIES) {
                setLoadingSeries(false)
              }
              if (data.eventDetail.data.publicationDate !== null) {
                setPublicationDate(
                  new Date(
                    new Date(Number(data.eventDetail.data.publicationDate))
                      .toISOString()
                      .slice(0, -1)
                  )
                )
              }
              setAudience(data.eventDetail.data.overHundredParticipants ? 3000 : 500)
            }
          }
        }
      } catch (error) {
        console.log(error)
      }
    }
    const bookingLoad = async () => {
      try {
        setBookingLoading(true)
        setBookingCount(0)

        const { data } = await getBooking(Number(id))
        if (data) {
          if (data.booking.statusCode === 200) {
            const booking = data.booking.data
            if (booking[0]?.category === 'live') {
              setEventLiveDate(
                new Date(
                  new Date(Number(booking[0].date)).toISOString().slice(0, -1)
                )
              )
              setLiveDuration(booking[0].endTime - booking[0].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[0].startTime
              )
              setLiveSlot(bookingSelectedStartTime)
            }

            if (booking[1]?.category === 'live') {
              setEventLiveDate(
                new Date(
                  new Date(Number(booking[1].date)).toISOString().slice(0, -1)
                )
              )
              setLiveDuration(booking[1].endTime - booking[1].startTime)
              let bookingSelectedStartTime: any = convertMinutesIntoTime(
                booking[1].startTime
              )
              setLiveSlot(bookingSelectedStartTime)
            }
            saveBookingDataToLocalStorage(
              dryDuration,
              selectedDrySlot,
              publicationDate,
              liveDuration,
              selectedLiveSlot,
              eventLiveDate
            )

            setLoading(false)
          }

          setBookingLoading(false)
          setBookingCount(data.booking.data.length)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (id !== undefined) {
      loadEventData()
      bookingLoad()
    }
  }, [])

  useEffect(() => {
    const loadBookedSlotsPerDate = async (
      eventId: number,
      category: string
    ) => {
      try {
        const { data } = await bookedSlotsPerDate(eventId, {
          audience,
          category
        })

        if (data.bookedSlotsPerDate.statusCode === 200) {
          setLiveSlotsPerDate(data.bookedSlotsPerDate.data)
        }
      } catch (error) {
        console.log(error)
      }
    }

    if (audience) {
      getTimeSlots(liveDuration, 'live')
      loadBookedSlotsPerDate(Number(id), 'live')
    }
  }, [audience, liveDuration])

  const showErrorPopup = () => {
    setErrorMessage(true)
    setTimeout(() => {
      setErrorMessage(false)
    }, 3000)
  }

  const getNextAvailableDate = (
    date: Date | null,
    duration: number
  ) => {
    if (!date) return null
    const blockedDates = getBlockedDates(duration)

    let minimumDate = moment(minimumLiveDate)
    let currentDate = moment(date)
    if (currentDate.isBefore(minimumDate)) currentDate = minimumDate
    while (true) {
      if (!blockedDates.includes(currentDate.format('YYYY-MM-DD'))) break
      currentDate = currentDate.add(currentDate.day() === 5 ? 3 : 1, 'day')
    }

    return currentDate.toDate()
  }

  const handleLiveDuration = async (event: SelectChangeEvent) => {
    if (+event.target.value === liveDuration) return

    setErrorMessage(false)
    setLiveDuration(parseInt(event.target.value))
    setLiveSlot('')
    setEventLiveDate(getNextAvailableDate(eventLiveDate, +event.target.value))
    await getTimeSlots(Number(event.target.value), 'live')
  }

  const getTimeSlots = async (duration: number, category: string) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(publicationDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    try {
      const { data } = await availableTimeSlots(Number(id), input)
      if (data) {
        if (data.availableTimeSlots.statusCode === 200) {
          if (category === 'live') {
            setLiveTimeSlots(data.availableTimeSlots.data)
          }
        }
      }
    } catch (error) {
      displayServerError()
    }
  }

  useEffect(() => {
    getTimeSlots(Number(liveDuration), 'live')
  }, [eventLiveDate])

  useEffect(() => {
    if (!bookingLoading && bookingCount === 0) {
      setEventLiveDate(getNextAvailableDate(eventLiveDate, liveDuration))
    }
  }, [bookingLoading, liveSlotsPerDate])

  const getSelectedSlotRoomId = async (
    selectedSlot: string,
    duration: number,
    category: string
  ) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(publicationDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    let slotRoomId: any = 0

    try {
      const { data } = await selectedSlotRoomId(
        selectedSlot,
        Number(id),
        event.eventType,
        input
      )
      if (data) {
        if (data.selectedSlotRoomId.statusCode === 200) {
          if (category === 'live') {
            slotRoomId = data.selectedSlotRoomId.data.slotRoomId
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
    return slotRoomId
  }

  const navigate = useNavigate()

  const backClick = async () => {
    if (event.eventType === 'Webinar') navigate('/audience/' + Number(id))
    else navigate('/event/staff/' + Number(id))
  }

  const eventPublicationDate = async (event: any) => {
    const input: any = {
      publicationDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD')
    }
    try {
      const results = await updatePublicationDate(event.id, input)
      const { data } = results
      if (data) {
        if (data.updatePublicationDate.statusCode === 200) {
          //navigate('/event/staff/'+eventData.id);
        }
      }
    } catch (error) {
      //displayServerError()
    }
  }

  const nextClick = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) {
      setValidationMessage('Please select live duration')
      showErrorPopup()
      return
    }
    if (liveStartTime === 0) {
      setValidationMessage('Please select live start time')
      showErrorPopup()
      return
    }
    if (eventLiveDate && publicationDate && moment(publicationDate).isBefore(moment(eventLiveDate).startOf('day'))) {
      setValidationMessage('Publication date cannot be before recording date')
      showErrorPopup()
      return
    }

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) {
        setValidationMessage('Live Event room not available')
        showErrorPopup()
        return
      }

      let seriesEventError = ''
      for (let i = 0; i < serialEvents.length; i++) {
        if (serialEvents[i].id !== Number(id)) {
          let roomBookings = serialEvents[i].roomBooking
          let liveData = roomBookings.find((x: any) => x.category === 'live')
          if (!liveData) {
            seriesEventError = 'Please provide live dates for series events'
            break
          }
        }
      }

      if (seriesEventError) {
        setValidationMessage(seriesEventError)
        showErrorPopup()
        return
      }

      const { data } = await bookTimeSlotsLive(liveRoomId, 0, Number(id), input)
      if (data) {
        if (data.bookTimeSlotsLive.statusCode === 200) {
          await eventPublicationDate(event)
          navigate('/event/featuresAndRequests/' + event.id)
        } else if (data.bookTimeSlotsLive.statusCode === 404) {
          setValidationMessage(data.bookTimeSlotsLive.message)
          showErrorPopup()
        } else {
          setValidationMessage('Internal server error')
          showErrorPopup()
        }
      } else {
        setValidationMessage('Internal server error')
        showErrorPopup()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const makeSeriesEvent = async (setSerialEvent: any) => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) {
      setValidationMessage('Please select live duration')
      showErrorPopup()
      return
    }
    if (liveStartTime === 0) {
      setValidationMessage('Please select live start time')
      showErrorPopup()
      return
    }
    if (eventLiveDate && publicationDate && moment(publicationDate).isBefore(moment(eventLiveDate).startOf('day'))) {
      setValidationMessage('Publication date cannot be before recording date')
      showErrorPopup()
      return
    }

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) {
        setValidationMessage('Live Event room not available')
        showErrorPopup()
        return
      }

      const { data } = await bookTimeSlotsLive(liveRoomId, 0, Number(id), input)
      if (data) {
        if (data.bookTimeSlotsLive.statusCode === 200) {
          setSerialEvent(true)
          //navigate('/featuresAndRequests/' + event.id)
        } else if (data.bookTimeSlotsLive.statusCode === 404) {
          setValidationMessage(data.bookTimeSlotsLive.message)
          showErrorPopup()
        } else {
          setValidationMessage('Internal server error')
          showErrorPopup()
        }
      } else {
        setValidationMessage('Internal server error')
        showErrorPopup()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const saveExit = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) return navigate('/')
    if (liveStartTime === 0) return navigate('/')

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }
    try {
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) return navigate('/')

      await bookTimeSlotsLive(liveRoomId, 0, Number(id), input)

      navigate('/')
    } catch (error) {
      navigate('/')
    }
  }

  const saveMainBooking = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)
    if (liveDuration === 0) return
    if (liveStartTime === 0) return

    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) return

      await bookTimeSlotsLive(liveRoomId, 0, Number(id), input)
      await eventPublicationDate(event)
    } catch (error) {
      console.log(error)
    }
  }

  const removeSerialEvent = (eventId: number) => {
    setSerialEvents(serialEvents.filter(x => x.id !== eventId))
  }

  const getBlockedDates = (duration?: number) => {
    let blockedDates: string[] = []

    Object.entries(liveSlotsPerDate).forEach((x: any) => {
      if (!x[1][duration || liveDuration]) blockedDates.push(x[0])
    })

    return blockedDates
  }

  return (
    <Box style={root}>
      <ProgressBar
        activePageTitle='Date & Times'
        requestType={event.eventType}
      />
      <Item sx={{ bgcolor: 'rgba(0, 0, 0, 0.02)' }}>
        <EventTitle title={event.title} />

        <Box
          style={container}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Grid
            container
            style={flexcol}
            sx={{
              maxWidth: '934px',
              justifyContent: 'center',
              padding: '32px !important',
              paddingBottom: '8px',
              background: '#FFFFFF',
              gap: '32px',
              borderRadius: '32px',
              marginTop: '32px',
              marginBottom: '32px'
            }}
          >
            {showErrorMessage && (
              <Grid item xs={12} sm={12} md={12} style={flexItemCenter}>
                {showErrorMessage && (
                  <Message message={validationMessage} isError={true} />
                )}
              </Grid>
            )}
            {/* Page Title */}
            <Grid item sm={12} sx={{ display: 'flex', flexDirection: 'row' }}>
              <Box
                sx={{
                  height: '40px',
                  width: '40px',
                  background: 'rgba(0, 107, 215, 0.1)',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: '16px'
                }}
              >
                <Box
                  component='img'
                  src={dateAndTimeIcon}
                  alt='Date and Time Icon'
                />
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <Typography align='left' variant='h5'>
                  Date & Times
                </Typography>
              </Box>
            </Grid>

            {/* Event Recording Date */}

            <EventDateAndTime
              eventName={'Event Recording'}
              minimumDate={minimumLiveDate}
              eventDate={eventLiveDate!}
              duration={liveDuration}
              setEventDate={setEventLiveDate}
              setLiveSlot={setLiveSlot}
              handleDuration={handleLiveDuration}
              selectedSlot={selectedLiveSlot}
              availableSlots={liveTimeSlots}
              clickSlot={clickLiveSlot}
              blockedDates={getBlockedDates()}
              faqDate='Select the Recording Date and time you and your speakers/presenters will be available. Come prepared to record your content. Plan to record with sufficient time to allow for multiple takes.'
              faqTime='Select from a list of available start times based on your previous date selection above.'
            />

            <EventDateAndTime
              eventName={'Event Publication'}
              minimumDate={minimumPublicationDate}
              eventDate={publicationDate!}
              duration={liveDuration}
              setEventDate={setPublicationDate}
              faqDate='The Event Publication Date is the day you would like your recording to go live. Typical recording production is approximately 5 business days. Each webcast requires a transcript to be 508-compliant. You may use your webcast script as a transcript, so long as your script is accurate to what was said during the recording. If you cannot use your webcast script, you will need a transcript. Should you need a transcript made for you, once the final version of your webcast is approved by you, it will take us 2-3 business days to complete the transcript. We will attempt to honor your requested publication date, but multiple rounds of edits, transcript production and other non-typical requests may impact the publication date.'
            />

            <HorizontalLine />

            {event.eventType === EventType.SERIES && (
            <SeriesEvents
              isSerialEvent={isSerialEvent}
              setSerialEvent={setSerialEvent}
              setSerialEvents={setSerialEvents}
              setLoadingSeries={setLoadingSeries}
              makeSeriesEvent={makeSeriesEvent}
              saveMainBooking={saveMainBooking}
              removeSerialEvent={removeSerialEvent}
              eventType={event.eventType}
            />
            )}
            {/* Event Recording Date */}
          </Grid>
        </Box>

        <Footer
          saveExit={saveExit}
          nextClick={nextClick}
          backClick={backClick}
          activePageTitle='Date & Times'
          canMoveNext={true}
        />
      </Item>

      <ProcessingDialog
        open={isLoading || isLoadingSeries}
        message='Loading...'
      />
    </Box>
  )
}
